const store = require('@/store/').default
const { OPEN_MODAL } = require('@/store/action-types')
const { CLOSE_MODAL } = require('@/store/action-types')

export default {
  /**
  * アラートモーダル呼び出し関数
  * @param {string} message - エラーメッセージ
  * @param {string} title - エラータイトル
  * @param {string} buttonMessage - ボタン文字列
  * @param {object} otherPageMoveObj - 別画面遷移オブジェクト（ $router.pushの第一引数に渡す利用方法となる。 ）
  */
  alert (message, title = 'エラーが発生しました', buttonMessage = '閉じる', otherPageMoveObj = null) {
    store.dispatch(OPEN_MODAL, {
      component: 'modal-alert-v3',
      params: {
        message,
        title,
        buttonMessage,
        otherPageMoveObj
      }
    })
  },
  /**
  * メンテパック解約アラートモーダル呼び出し関数
  * @param {string} message - メッセージ
  * @param {array} headersInfo - 解約API呼び出しに必要なヘッダー情報
  */
  mpCancelAlert (message, headersInfo) {
    store.dispatch(OPEN_MODAL, {
      component: 'mp-cancel-modal-alert-v3',
      params: {
        message,
        title: '最終確認',
        buttonMessage: '解約する',
        headersInfo
      }
    })
  },
  /**
  * メンテパック入会金支払い催促アラートモーダル呼び出し関数
  * @param {string} message - メッセージ
  */
  admissionFeeReminderAlert (message) {
    store.dispatch(OPEN_MODAL, {
      component: 'admission-fee-reminder-alert-v3',
      params: {
        message,
        title: 'お願い',
        buttonMessage: '閉じる'
      }
    })
  },
  /**
  * メンテパック特定商取引法の表記アラートモーダル呼び出し関数
  */
  mpSpecifiedCommercialTransactionsAlert (title = '【特定商取引法の表記】', buttonMessage = '戻る') {
    store.dispatch(OPEN_MODAL, {
      component: 'mp-specified-commercial-transactions-alert-v3',
      params: {
        title,
        buttonMessage
      }
    })
  },
  /**
  * 完了アラートモーダル呼び出し関数
  * @param {string} message - メッセージ
  */
  completeModal (message, title) {
    store.dispatch(OPEN_MODAL, {
      component: 'complete-modal-alert-v3',
      params: {
        message,
        title,
        buttonMessage: '閉じる'
      }
    })
  },

  confirm (message, onOk, onNg) {

  },

  openComponent (component) {
  },

  close () {
    store.dispatch(CLOSE_MODAL)
  },

  closeAll () {
  }
}
